<template>
    <div class="banner-list">
        <div class="td-card banner" v-for="banner in displayBanners" :key="banner.id">
            <a class="banner-image" :href="banner.websiteAddress" target="_blank" rel="nofollow">
                <v-lazy-image :src="'/banners/load-banner-image/' + banner.id" alt="Banner" width="480" height="60"></v-lazy-image>
            </a>
            <div class="lg-col-3">
                <div>
                    <strong>Status:</strong> {{ banner.status }}<br />
                    <strong>Link:</strong> <a :href="banner.websiteAddress" target="_blank" rel="nofollow">{{ banner.websiteAddress }}</a><br />
                </div>
                <div>
                    <strong>Banner Type:</strong> {{ banner.type }}<br />
                    <strong>Location:</strong> {{ banner.location }}<br />
                </div>
                <div>
                    <strong>Services:</strong> {{ banner.services }}<br />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import script from './BannerList';
    export default script;</script>

<style lang="less">
    @import "./BannerList.less";
</style>